module.exports = __webpack_public_path__ + "1811652a79a340f5f6ae7afd3dd34ada.png";